export const Adjectives = [
    "Sustainable",
    "Organic",
    "Innovative",
    "Efficient",
    "Productive",
    "Diverse",
    "Resilient",
    "Community-oriented",
    "Eco-friendly",
    "Traditional",
    "Modern",
    "Labor-intensive",
    "Profitable",
    "Holistic",
    "Adaptive",
    "Regenerative",
    "Nutrient-rich",
    "Environmentally-conscious",
    "Technologically-advanced",
    "Crop-specific",
    "Quality-focused",
    "Family-run",
    "Small-scale",
    "Large-scale",
    "Intensive",
    "Extensive",
    "Local",
    "Global",
    "Weather-dependent",
    "Soil-focused",
    "Market-driven",
    "Biodiverse",
    "Cooperative",
    "Time-efficient",
    "Resource-efficient",
    "Risk-managed",
    "Economical",
    "Reliable",
    "Integrated",
    "Climate-smart",
    "Community-supported",
    "Value-added",
    "Educational",
    "Research-driven",
    "Labor-efficient",
    "Crop-diverse",
    "Soil-enriching",
    "Nutrient-dense",
    "Pest-resistant",
    "Disease-resistant",
    "Technologically-integrated",
    "Wildlife-friendly",
    "Heritage-focused",
    "Long-term-oriented",
    "Flexibly-managed",
    "Land-conserving",
    "Knowledge-based",
    "Profit-sharing",
    "Water-efficient",
    "Low-impact",
    "Conservation-minded",
    "Productivity-enhancing",
    "Quality-assured",
    "Local-market-oriented",
    "Community-engaged",
    "Educationally-oriented",
    "Health-conscious",
    "Economically-viable",
    "Fresh",
    "High-quality",
    "Nutritional",
    "Palatable",
    "Dry",
    "Green",
    "Aromatic",
    "Leafy",
    "Soft",
    "Coarse",
    "Dense",
    "Clean",
    "Well-cured",
    "High-protein",
    "Low-moisture",
    "Sweet-smelling",
    "Uniform",
    "Versatile",
    "Seasonal",
    "Bale-aged",
    "Grassy",
    "Leguminous",
    "Rich",
    "Fluffy",
    "Tasty",
    "Soft-stemmed",
    "Coarse-stemmed",
    "Light-weight",
    "Vibrant",
    "Nutritious",
    "Fragrant",
    "Protective",
    "Stable",
    "Harvest-ready",
    "Quality-controlled",
    "Smooth",
    "Green-hued",
    "Richly-textured",
    "Well-structured",
    "Soft-fibered",
    "Drought-resistant",
    "High-fiber",
    "Farm-fresh",
    "Moisture-preserving",
    "Fertility-enhancing",
    "Easy-to-store",
    "Quality-tested",
    "Animal-friendly",
    "Balanced",
    "Silage-ready",
    "Nutrient-balanced",
    "Pleasant-smelling",
    "Well-mixed",
    "Colorful",
    "High-yielding",
    "Climate-resilient",
    "Easy-to-handle",
    "Bacterial-resistant",
    "Mold-free",
    "Dust-free",
    "Low-ash",
    "Non-toxic",
    "Digestible",
    "High-energy",
    "Rich-in-minerals",
    "Highly-marketable",
    "Well-managed",
    "Farm-to-table",
    "Holistically-managed",
    "Tradition-rooted",
    "Research-backed",
    "Profit-maximizing",
    "Environmentally-advantageous",
    "Socially-responsible",
    "Knowledge-sharing",
    "Safety-oriented",
    "Cross-culturally-engaged",
    "Eco-sustainable",
    "Waste-reducing",
    "Landscape-enhancing",
    "Multi-functional",
    "Energy-efficient",
    "Labor-saving",
    "Quality-driven",
    "Economically-sustainable",
    "Regionally-adapted",
    "Educationally-focused",
    "Water-conserving",
    "Carbon-neutral",
    "Process-optimized",
    "Community-resilient",
    "Soil-conserving",
    "Yield-maximizing",
    "Climate-adaptive",
    "Health-promoting",
    "Equitable",
    "Biodiversity-enhancing",
    "Farmer-friendly",
    "Market-responsive",
    "Urban-agriculture-friendly",
    "Ecosystem-supportive",
    "Farm-supportive",
    "Land-restorative",
    "Wildlife-supportive",
    "Crop-diversifying",
    "Labor-empowering",
    "Economically-inclusive",
    "Knowledge-driven",
    "Community-building",
    "Adaptable",
    "Climate-responsive",
    "Resource-conserving",
    "Biodynamic",
    "Future-oriented",
    "Soil-restoring",
    "Engaging",
    "Local-food-promoting",
    "Crop-enhancing"
]